import { CommentModel } from "../schema/comments.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class CommentContainer extends MongoBaseContainer{
    comment:CommentModel;
}